(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-image-with-title"]) return;
  try {
    
  ;(() => {
    function initialize(root) {
      if (root.dataset.agcAccessoriesReady === 'true') return;

      const getItems = () => Array.from(document.querySelectorAll('.collection-accessories #CollectionLoop [data-grid-item]'));
      const filterButtons = Array.from(root.querySelectorAll('[data-agc-filter]'));
      const status = root.querySelector('[data-agc-filter-status]');
      const bestSellersLink = root.querySelector('a[href="#agc-accessories-best-sellers"]');
      const categoryHandles = {
        enclosure: ['doorguards', 'wind-seal-kit-golf-cart-enclosure-accessory', 'rubber-weather-stripping', 'standout-latch'],
        comfort: ['heated-steering-wheel', 'kozip-front-seat-cushion-set', 'basic-front-seat-upgrade-kit'],
        'audio-power': ['reno-golf-cart-sound-bar', 'dual-usb-12v-charger-for-golf-cart-phone-and-accessories-1', '4-gauge-cable-install-pack', '6-gauge-cable-install-pack'],
        'golf-utility': ['dry-club-golf-bag-protector-cover', 'universal-golf-club-and-ball-washer-cleaner']
      };

      function getHandle(item) {
        const link = item.querySelector('a[data-product-link]');
        if (!link) return '';
        return link.getAttribute('href').split('/products/')[1]?.split('?')[0] || '';
      }

      function isMatch(item, filter) {
        const handle = getHandle(item);
        if (filter === 'all') return true;
        if (filter === 'in-stock') return !item.textContent.toLowerCase().includes('sold out');
        if (filter === 'under-100') {
          const price = item.querySelector('.new-price, [data-product-price], .price');
          const match = price?.textContent.replace(/,/g, '').match(/[0-9]+(?:\.[0-9]{2})?/);
          return match ? Number(match[0]) < 100 : false;
        }
        if (filter === 'lighting') return handle.includes('light-kit') || handle.includes('headlight-kit');
        return categoryHandles[filter]?.includes(handle) || false;
      }

      function applyFilter(filter, shouldScroll) {
        const items = getItems();
        const update = () => {
          let visible = 0;
          items.forEach((item) => {
            const show = isMatch(item, filter);
            item.hidden = !show;
            if (show) visible += 1;
          });

          filterButtons.forEach((button) => {
            button.setAttribute('aria-pressed', String(button.dataset.agcFilter === filter));
          });

          if (status) status.textContent = `${visible} ${visible === 1 ? 'product' : 'products'} shown`;
        };

        if (document.startViewTransition) {
          document.startViewTransition(update);
        } else {
          update();
        }

        if (shouldScroll) {
          document.getElementById('agc-accessories-all-products')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }

      filterButtons.forEach((button) => {
        button.addEventListener('click', () => applyFilter(button.dataset.agcFilter, true));
      });

      bestSellersLink?.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();
        document.getElementById('agc-accessories-best-sellers')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, { capture: true });

      applyFilter('all', false);
      root.dataset.agcAccessoriesReady = 'true';
    }

    document.querySelectorAll('[data-agc-accessories]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-agc-accessories]').forEach(initialize);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yamaha-shop-by-cart"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const labels = {
      drive: 'Yamaha Drive G29 / Drive2',
      umax: 'Yamaha UMAX',
      concierge: 'Yamaha Concierge'
    };
    const allowedPassengers = {
      drive: ['2', '4'],
      umax: ['2'],
      concierge: ['6']
    };

    function initialize(root) {
      if (root.dataset.yamahaReady === 'true') return;
      root.dataset.yamahaReady = 'true';

      const modelButtons = [...root.querySelectorAll('[data-model]')];
      const passengerButtons = [...root.querySelectorAll('[data-passenger]')];
      const resultPanels = [...root.querySelectorAll('[data-combo]')];
      const selectionSummary = root.querySelector('[data-selection-summary]');
      const results = root.querySelector('.agc-yamaha__results');
      let selectedModel = 'drive';
      let selectedPassenger = '2';

      function updateResults() {
        const combination = `${selectedModel}-${selectedPassenger}`;
        resultPanels.forEach((panel) => {
          panel.hidden = !panel.dataset.combo.split(' ').includes(combination);
        });
        selectionSummary.textContent = `${labels[selectedModel]} · ${selectedPassenger} Passenger`;
      }

      function selectPassenger(passenger, scrollToResults) {
        selectedPassenger = passenger;
        passengerButtons.forEach((button) => {
          button.setAttribute('aria-pressed', String(button.dataset.passenger === passenger));
        });
        updateResults();
        if (scrollToResults) {
          const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          results.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
        }
      }

      function selectModel(model) {
        selectedModel = model;
        modelButtons.forEach((button) => {
          button.setAttribute('aria-pressed', String(button.dataset.model === model));
        });

        const allowed = allowedPassengers[model];
        passengerButtons.forEach((button) => {
          button.disabled = !allowed.includes(button.dataset.passenger);
        });

        if (!allowed.includes(selectedPassenger)) selectedPassenger = allowed[0];
        selectPassenger(selectedPassenger, false);
      }

      modelButtons.forEach((button) => {
        button.addEventListener('click', () => selectModel(button.dataset.model));
      });

      passengerButtons.forEach((button) => {
        button.addEventListener('click', () => {
          if (!button.disabled) selectPassenger(button.dataset.passenger, true);
        });
      });

      selectModel(selectedModel);
    }

    document.querySelectorAll('[data-yamaha-shop]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-yamaha-shop]').forEach(initialize);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
